export type Blog = {
    title: string;
    description: string;
    blog?: number;
    blogId?: string;
    category?: string;
    openInNew?: boolean;
};

type BlogCollection = {
    [key: string]: any;
};
export type BlogArticle = {
    id: number;
    documentId: string;
    Title: string;
    Slug: string;
    ButtonText: string;
    Thumbnail: {
        url: string;
        formats: {
            large: { url: string };
            medium: { url: string };
            small: { url: string };
            thumbnail: { url: string };
        };
    };
    blog: {
        id: number;
        documentId: string;
        Title: string;
        Description: string;
        Slug: string;
    };
    content: Array<{
        __component: string;
        id: number;
        text?: string;
        subId?: string;
        content?: string;
    }>;
};
type BlogResponse = {
    data: BlogArticle;
    meta: any;
};

const fetchBlogArticle = async (documentId: string): Promise<any> => {
    try {
        const response = await fetch(`https://content.ecofutures.io/api/blog-articles/${documentId}?populate=*`);
        const data: BlogResponse = await response.json();

        if (data.data) {
            const subtitle = data.data.content.find((item) => item.__component === "blog.subtitle")?.text || "";
            const paragraph = data.data.content.find((item) => item.__component === "blog.paragraph")?.content || "";
            const buttonText = data.data.ButtonText || "";

            return {
                title: subtitle,
                description: paragraph,
                image: data.data.Thumbnail?.url,
                subtitle: subtitle,
                paragraph: paragraph,
                id: data.data.id,
                path: data.data.blog?.Slug,
                buttonText: buttonText,
            };
        }
        return null;
    } catch (error) {
        console.error("Failed to fetch blog article:", error);
        return null;
    }
};
export const blogs: BlogCollection = {
    "1": {
        blog: 1,
        documentId: "txjiexnfxru23yo1640xn18g",
        Slug: "blog-article-1",
    },
    "2": {
        blog: 2,
        documentId: "iwmvrgzuwzhe2k9rxgth6zom",
        Slug: "blog-article-2",
    },
    "3": {
        blog: 3,
        documentId: "gp9whbe049i67sm3obi9xd5p",
        Slug: "blog-article-3",
    },
    "4": {
        blog: 4,
        documentId: "yydr70wi6t9hnsf3n789q4n6",
        Slug: "blog-article-4",
    },
    "5": {
        blog: 5,
        documentId: "v3wqm7ytdsrrkkbe35st84cl",
        Slug: "blog-article-5",
    },
};

export const initializeBlogContent = async () => {
    const blogContent: BlogCollection = {};

    // Fetch content for each blog
    for (const [key, blog] of Object.entries(blogs)) {
        if (blog.documentId) {
            const content = await fetchBlogArticle(blog.documentId);
            if (content) {
                blogContent[key] = {
                    ...blog,
                    ...content
                };
            }
        }
    }

    return blogContent;
};

